import { cmsApi } from '@commerce-webcomponents/sdk';
import { cartCmsDataType, SopElementResponse } from '@commerce-cart-webcomponents/sdk';
import { Logger } from '@nextgen-web-framework/core';
import { SubcriptionPlanCMSResponseType } from '@commerce-subscription-webcomponents/sdk';

const loggerInstance = Logger.getInstance();
export const fetchCmsContent = async () => {
  try {
    const data = await cmsApi.fetchContent({
      uId: 'cart',
    });
    return data as cartCmsDataType;
  } catch (error) {
    loggerInstance.log('Error fetching content:', error);
    throw error;
  }
};

export const fetchSubscriptionCMSContent = async (sopMetaData: SopElementResponse[]) => {
  const data: string[] = [];
  sopMetaData.forEach((sopElement: SopElementResponse) => {
    data.push(`"${sopElement?.planCode}"`);
  });
  try {
    const response = await cmsApi.fetchAllContent({
      uId: 'subscription_plan',
      params: [
        {
          key: 'query',
          value: `{"plan_code":{"$in":[${data}]}}`,
        },
      ],
    });
    return response as SubcriptionPlanCMSResponseType[];
  } catch (error) {
    loggerInstance.log('Error fetching content:', error);
    throw error;
  }
};
